<template>
  <div class="home-page">
    <banner></banner>
    <!-- <home-body-phone class="phone-show"
      ><Choose-package :all-packages="allPackages"></Choose-package
    ></home-body-phone> -->
    <home-body-pc class="pc-show"
      ><Choose-package :all-packages="allPackages"></Choose-package
    ></home-body-pc>
    
    <BannerPopup></BannerPopup>

    <home-footer></home-footer>
  </div>
</template>

<script>
import Banner from "./homeBanner/HomeBanner.vue";
import HomeBodyPc from "./homeBodyPc/HomeBodyPc.vue";
import HomeBodyPhone from "./homeBodyPhone/HomeBodyPhone.vue";
import ChoosePackage from "./choosePackage/ChoosePackageNew.vue";
import HomeFooter from "../../components/footer/Footer.vue";
import cookie from "../../lib/cookie";
import BannerPopup from "../../components/bannerPopup/BannerPopup.vue"

export default {
  name: "home-view",
  components: {
    Banner,
    HomeBodyPc,
    HomeBodyPhone,
    ChoosePackage,
    HomeFooter,
    BannerPopup
  },
  data() {
    return {
      allPackages: [],
    };
  },
  computed: {
    mediaType() {
      return this.$store.state.mediaType;
    },
    hasToken() {
      return this.$store.state.hasToken
    },
  },
  created() {
    if (this.$route.query.utm_campaign) {
      window.sessionStorage.setItem(
        "utmCampaign",
        this.$route.query.utm_campaign
      );
    }
    if (this.$route.query.invite_code) {
      cookie.setCookie("invite_code", this.$route.query.invite_code, 30);
    }
  },
  watch: {
    hasToken(val) {
      this.loadPackages()
    }
  },
  mounted() {
    this.loadPackages();
  },
  methods: {
    loadPackages() {
      if (!this.hasToken) {
        this.$store.commit("setNeedAuthorization", false);
      }
      this.$http
        .get("api/v2/topup-packages", {
          headers: {
            "Cache-Control": "no-cache",
          },
        })
        .then((response) => {
          this.allPackages = response.body.data;
          window.sessionStorage.removeItem("needUseNoCache");
        });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../assets/scss/variables";

.home-page {
  overflow: hidden;
  max-width: 100vw;
}
.phone-show {
  display: none;
}
.pc-show {
  display: block;
}
@media (min-width: 768px) {
  .phone-show {
    display: none;
  }
  .pc-show {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?201fcd1a